import React from 'react';
import {
    SectionWrapper,
    SectionHeader,
    SectionImageWrapper,
    SectionContainer,
    StyledSectionDescription,
    SectionHeaderLogoWrapper,
    SectionHeaderLogoText
} from './SectionStyles';
import styled from "styled-components";
import { Image } from "UI-Dash-Commons-UI";

const Section3Image = require( '../images/screen3-appdiscovery-graphic-map.png');
const Section3ImageAltText = 'appDiscoveryImage';
const Section3ImageWidth = '300px';
const Section3ImageHeight = '188px';

const SectionLogo = require('../images/screen3-appdiscovery-logo.svg');
const SectionLogoAltText = 'logo';
const SectionLogoWidth = '200px';
const SectionLogoHeight = '32px';

const HeaderLogoText = 'Our Solutions';
const SectionHeaderText = 'Find the right users at massive scale.';
const SectionDescriptionText = '8B+ app installs driven through our marketing platform.';

const Section3: React.FunctionComponent = () => {

    return <SectionContainer>
        <SectionWrapper>
            <SectionHeaderLogoWrapper>
                <SectionHeaderLogoText>
                    {HeaderLogoText}
                </SectionHeaderLogoText>
                <Image
                    alt={SectionLogoAltText}
                    src={SectionLogo}
                    width={SectionLogoWidth}
                    height={SectionLogoHeight}
                />
            </SectionHeaderLogoWrapper>
            <StyledSectionHeader>
                {SectionHeaderText}
            </StyledSectionHeader>
            <StyledSectionDescription>
                {SectionDescriptionText}
            </StyledSectionDescription>
            <StyledImageWrapper>
                <Image
                    alt={Section3ImageAltText}
                    src={Section3Image}
                    width={Section3ImageWidth}
                    height={Section3ImageHeight}
                />
            </StyledImageWrapper>
        </SectionWrapper>
    </SectionContainer>;
};


const StyledImageWrapper = styled( SectionImageWrapper )`
    margin: 26px 65px 0px 65px;
`;

const StyledSectionHeader = styled( SectionHeader )`
    margin: 0 105px 16px 105px;
    font-size: 20px;
    line-height: 27px;
`

export default Section3;
